import ResourceActivityList from '@/components/ResourceActivityList';
import { useSiteActivities } from '@/hooks/sites/useSiteActivities';

const SiteActivity = ({ siteId }: { siteId: string }) => {
  const { activities, isLoading } = useSiteActivities(siteId);
  return <ResourceActivityList activities={activities} isLoading={isLoading} />;
};

export default SiteActivity;
